import React, { useState, useEffect, useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SidebarProvider, SidebarInset } from '../ui/sidebar'
import { AppSidebar } from './AppSidebar'
import { Header } from './Header'
import { Toaster } from '../ui/toaster'
import { useAdminSocketInit } from '../../hooks/useAdminSocketInit'
import { useNavCounts } from '../../hooks/useNavCounts'
import { getRouteIdFromPath } from '../../config/routes'
import { useAuth } from '../../contexts/AuthContext'
import type { UserRole } from '../data/orderWorkflowData'

export const Layout: React.FC = () => {
  const location = useLocation()
  const { user } = useAuth()
  const userRole = useMemo(() => (user?.frontendRole ?? 'customer') as UserRole, [user])
  const { data: navCountsData } = useNavCounts(userRole, user?.id)
  const badgeCounts = navCountsData ?? {}

  const [currentPage, setCurrentPage] = useState<string>(() => {
    return getRouteIdFromPath(location.pathname)
  })

  // Real-time funksiyalar üçün soketin qlobal inisializasiyası
  useAdminSocketInit()

  // Location dəyişdikdə currentPage-i yeniləyirik
  useEffect(() => {
    const routeId = getRouteIdFromPath(location.pathname)
    setCurrentPage(routeId)
  }, [location.pathname])

  const handlePageChange = (page: string) => {
    setCurrentPage(page)
  }

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar
          currentPage={currentPage}
          onPageChange={handlePageChange}
          userRole={userRole}
          badgeCounts={badgeCounts}
        />
        <SidebarInset className="flex-1 flex flex-col min-w-0">
          <Header userRole={userRole} />
          <main className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
              <Outlet />
            </div>
          </main>
        </SidebarInset>
      </div>
      <Toaster />
    </SidebarProvider>
  )
}

